import React, { Component } from 'react';
import ObjectPickerDialog from '../../common/ObjectPicker/ObjectPickerDialog';
import CardSearchCard from '../../cards/components/CardSearchCard';
import { Button, Text } from 'evergreen-ui';

import Request from '../../../util/Api';

class CardPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSearch: false
        }
    }

    toggleSearch(show = true) {
        this.setState({
            showSearch: show
        })
    }

    searchFunction(value) {
        return Request.get('/card-games/cards', null, { q: value, _start: 0, _end: 100 });
    }

    mapperFunction(value) {
        return value.data;
    }

    handleSubmit = (selection) => {
        this.props.onSubmit(selection);
    }

    render() {
        return (<>
            <ObjectPickerDialog
                single={false}
                label="Selecteaza unul sau mai multe singles"
                open={!!this.state.showSearch}
                onClose={() => { this.toggleSearch(false); }}
                onSubmit={(selection) => { this.handleSubmit(selection); }}
                searchFunction={this.searchFunction}
                mapFunction={this.mapperFunction}
                resultComponent={(props) => <CardSearchCard {...props} />} />

            <Button
                appearance="primary"
                iconBefore="add"
                type="button"
                onClick={() => { this.toggleSearch(true) }}>
                <Text color="#FFFFFF">Adauga Singles</Text>
            </Button>
        </>);
    }
}

export default CardPicker;
